const ALLOWED_HOSTS = new Set([
  'client.formpiper-dev.com',
  'client.formpiper.com',
  'app.formpiper-dev.com',
  'app.formpiper.com',
]);

export function isSafeReturnTo(url: string): boolean {
  try {
    const parsed = new URL(url);
    return ALLOWED_HOSTS.has(parsed.hostname);
  } catch {
    return !url.startsWith('//');
  }
}
